import { useMemo } from "react";
import useGetAlbums from "@/hooks/useGetAlbums";
import useGetArtist from "@/hooks/useGetArtist";
import { buildArcadeLineup, type ArcadeReleaseInput, type ArcadeSong, type ArcadeTopTrackInput } from "@/utils/arcade/lineup";

export const ARCADE_ARTIST = "Truevined";

export interface ArcadeArtist {
  name: string;
  images?: Array<{ url: string }>;
  topTracks?: ArcadeTopTrackInput[];
}

export interface ArcadeLineupState {
  releases: ArcadeReleaseInput[] | undefined;
  artist: ArcadeArtist | null;
  lineup: ArcadeSong[];
  loading: boolean;
  error: boolean;
}

// The arcade is Truevined's, like the merch store, so it always reads his
// artist record (for the popular order) and his release list.
export function useArcadeLineup(): ArcadeLineupState {
  const artistResponse = useGetArtist({ artistId: ARCADE_ARTIST }, null, [ARCADE_ARTIST]);
  const albumResponse = useGetAlbums({ artistId: ARCADE_ARTIST }, null, [ARCADE_ARTIST]);
  const artist = (artistResponse?.artistData as ArcadeArtist | undefined) ?? null;
  const albums = albumResponse?.albums as ArcadeReleaseInput[] | undefined;

  const lineup = useMemo(() => buildArcadeLineup(artist?.topTracks, albums), [artist?.topTracks, albums]);

  return {
    artist,
    releases: albums,
    lineup,
    loading: !artistResponse || !albumResponse,
    error: Boolean(artistResponse?.error || albumResponse?.error),
  };
}
